import * as Sentry from "@sentry/react";
import LogRocket from "logrocket";
import LogrocketFuzzySanitizer from "logrocket-fuzzy-search-sanitizer";

// -----------------------------------------------------------------------------

if (!process.env.REACT_APP_NO_LOGROCKET && !process.env.REACT_APP_NO_EXTERNAL) {
  const SentryPrivateFieldNames = [
    "JWT_RefreshToken",
    "JWT_AccessToken",
    "Authorization",
    "access",
    "refresh",
  ];

  //
  try {
    const { requestSanitizer, responseSanitizer } =
      LogrocketFuzzySanitizer.setup(SentryPrivateFieldNames);
    const release =
      // eslint-disable-next-line
      process.env.REACT_APP_VERSION_RELEASE || window.location.hostname;
    // envars can be empty strings, aka not null so ?? wouldn't work as intended

    LogRocket.init("vultip/threatkey", {
      release: `app@"${release}`,
      dom: {
        baseHref: "https://app.threatkey.com/",
      },
      rootHostname:
        process.env.REACT_APP_ENVIRONMENT === "production"
          ? "threatkey.com"
          : undefined,
      network: {
        // @ts-expect-error: I don't care
        requestSanitizer,
        // @ts-expect-error: I don't care
        responseSanitizer,
      },
    });

    LogRocket.getSessionURL((sessionURL) => {
      Sentry.configureScope((scope) => {
        scope.setExtra("sessionURL", sessionURL);
      });
    });
  } catch (error) {
    !process.env.CI && console.log(error);
  }
} else {
  console.info("LogRocket disabled");
}
